import { generateActions } from "../utils";

export const GET_COMPANIES = generateActions("GET_COMPANIES");
export const GET_COMPANY = generateActions("GET_COMPANY");
